import Swal from 'sweetalert2'

import { sequenceHtml } from './sequenceHtml'
import { 
  isPlainObject,
  sweetAlertCommonParams, 
  getSelectOptionsFromObject 
} from '../../functions/utils'
import { lang } from '../../assets/lang'

// eslint-disable-next-line
export const sequenceModal = async (oldData, node) => {
  const commonParams = sweetAlertCommonParams(node)
  
  return await Swal.fire({
    ...commonParams,
    title: lang.sequence_modal_title,
    html: sequenceHtml,

    willOpen: () => {
      $('.select2').select2({ 
        width: '100%',
        dropdownParent: $('#swal2-content')
      })

      var page_table_id = window.xitFlowBuilderData.page_table_id
      var base_url = window.xitFlowBuilderData.base_url
      var instagram_bot_addon = window.xitFlowBuilderData.instagram_addon

      $.ajax({
        type: 'POST',
        url: base_url+'visual_flow_builder/get_broadcast_tags',
        dataType: 'JSON',
        data: { page_table_id, requested_from: 'new_postback', instagram_bot_addon },
        success:function(response) {
          if (isPlainObject(response)) {
            const selectOptions = getSelectOptionsFromObject(response);
            $('#sequence-sequence-message-tag').append(selectOptions);
            $('#sequence-sequence-message-tag').val(oldData.messageTag || '').trigger('change')
          }
        }
      })      

      $('#sequence-sequence-name').val(oldData.name || '')
      $('#sequence-sequence-starting-time').val(oldData.startingTime || '').trigger('change')
      $('#sequence-sequence-closing-time').val(oldData.closingTime || '').trigger('change')
      $('#sequence-sequence-timezone').val(oldData.timezone || '').trigger('change')
      $('#sequence-sequence-message-tag').val(oldData.messageTag || '').trigger('change')
    },

    preConfirm: () => {
      const name = $('#sequence-sequence-name').val()
      const startingTime = $('#sequence-sequence-starting-time').val()
      const closingTime = $('#sequence-sequence-closing-time').val()
      const timezone = $('#sequence-sequence-timezone').val()

      const messageTag = $('#sequence-sequence-message-tag').val()
      const messageTagText = $('#sequence-sequence-message-tag option:selected').text()

      if (! name) {
        Swal.showValidationMessage(lang.sequence_modal_msg_name)
      }
  
      return {
        name,
        startingTime,
        closingTime,
        timezone,
        messageTag,
        messageTagText,
      }
    },    
  })
}